import React from "react";

import { Table, Pagination } from "clearsense-ui/components";

import { PAGE_SIZE_OPTIONS } from "../../constants";

const ResultTable = ({
  result,
  pageNumber,
  pageSize,
  totalRecords,
  setPageNumber,
  setPageSize,
}) => (
  <div style={{ height: "90%" }}>
    <Table
      fixedHeight
      totalCount={result.length}
      currentPageNumber={pageNumber}
      defaultPageSize={pageSize}
      allowRowClick={false}
      paginationProps={{ className: "hidden" }}
      columnData={Object.keys(result?.[0])
        .filter(columnName => !columnName.includes("airbyte"))
        .map(columnName => ({
          key: columnName,
          dataIndex: columnName,
          title: columnName,
          width: Math.max(12 * columnName.length, 200),
          ellipsis: true,
          render: cellValue => cellValue || "N/A",
        }))}
      rowData={result}
      className="text-xs"
      rowSelection={false}
      data-cy="sql-editor-result-table"
    />
    <Pagination
      showResultsPerPage
      currentPage={pageNumber}
      pageSize={pageSize}
      totalRecordsCount={totalRecords}
      setCurrentPage={setPageNumber}
      setPageSize={setPageSize}
      pageSizeOptionsList={PAGE_SIZE_OPTIONS}
      className="cs-ui-table-background"
    />
  </div>
);

export default ResultTable;
